<template>
    <Background
        :backPath="'prevPage'">
        <div class="info-area">
            <div class="title">
                货柜信息
            </div>
            <div class="info-paragraph">
                <div class="info-line">
                    <div class="info-label">
                        主控编号
                    </div>
                    <div class="content-area">
                        <div class="info-content">{{ boxSerialNum }}</div>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info-label">主控状态</div>
                    <div class="content-area">
                        <div class="info-content">{{ boxStatus }}</div>
                    </div>
                </div>

                <div class="info-line">
                    <div class="info-label">主控哈希</div>
                    <div class="content-area">
                        <div class="info-content">{{ boxHasPassword }}</div>
                    </div>
                </div>
            </div>
        </div>
    </Background>
</template>

<script>
 import Vue from 'vue';

 import Background from "./Background.vue"

 import Modal from "ant-design-vue/lib/modal";

 import message from "ant-design-vue/lib/message";
 import { parseDate } from "../util/date.js"

 Vue.component(Modal.name, Modal);

 export default {
     name: 'DeviceInfo',
     data() {
         return {
             boxSerialNum: "",
             boxStatus: "",
             boxHasPassword: "",
         }
     },
     props: {
     },
     components: {
         Background,
     },
     computed: {
     },
     mounted() {
         var info = JSON.parse(sessionStorage.getItem("clickDeviceInfo"))

         this.boxSerialNum = info.BoxSerialNum
         this.boxStatus = info.BoxStatus
         this.boxHasPassword = info.BoxHasPassword
     },
     methods: {
     },
 }
</script>

<style scoped>
 .info-area {
     width: 100%;
     height: 100%;
     padding-top: 80px;
     padding-left: 80px;
     padding-right: 80px;

     background-color: #FFF;

     position: relative;
 }

 .title {
     font-size: 24px;
     margin-left: 30px;
     margin-bottom: 20px;
     text-align: start;
 }

 .info-line {
     display: flex;
     flex-direction: column;
     justify-content: flex-start;
     width: 100%;
     border-right: 1px solid #EEE;
     padding-left: 30px;
 }

 .info-line:last-child {
     border-right: none;
 }

 .info-label {
     font-size: 18px;
     color: #333;
     width: 200px;
     text-align: start;
     margin-bottom: 10px;
     user-select: none;

     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .info-content {
     font-size: 16px;
     color: #999;
     text-align: start;
     height: 24px;
 }

 .info-paragraph {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: space-around;
     padding-top: 30px;
     padding-bottom: 30px;
     border-bottom: 1px solid #EFEFEF;
 }

 .content-area {
     display: flex;
     flex-direction: row;
     align-items: center;
 }

 .edit-button {
     margin-left: 5px;
     margin-bottom: 2px;
     font-size: 16px;
     color: #333;
     cursor: pointer;
 }

 .edit-button:hover {
     color: #587FE0;
 }

 .delete-button {
     position: absolute;
     bottom: 40px;
 }

 .type-check-group {
     display: flex;
 }

 .split-box {
     display: flex;
     flex-direction: row;
     width: 100%;
     height: 100%;
 }

 .log-area {
     width: 100%;
     background-color: #FFF;
     border-left: 1px solid #DDD;
 }

 .error-title {
     font-size: 20px;
 }

 .error-area {
     width: 100%;
     background-color: #FFF;
     border-left: 1px solid #EEE;

     display: flex;
     flex-direction: column;
     align-items: start;

     padding-top: 20px;
     padding-left: 20px;

     font-size: 16px;
 }

 .suberror-area {
     display: flex;
     flex-direction: column;
     align-items: start;
     margin-left: 20px;
 }

 .watch-shell-button {
     margin-left: 10px;
 }
</style>
